import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  Col,
  Form,
  Icon,
  Input,
  Modal,
  Row,
  Select,
  Tabs,
  Upload
} from 'antd'
import _ from 'lodash'
import {
  getBarcodeById,
  saveBarcodeProduct
} from '../../../../modules/barcodeProduct'
import { saveSelectedList } from '../../../../modules/material'
import { useDeepEffect } from '../../../../utils/hooks'
import {
  beforeUpload,
  compressFile,
  getBase64
} from '../../../../utils/services'
import ProductRecycleList from '../ProductRecycleList'
import Lightbox from "react-image-lightbox";
import "../../../../../node_modules/react-image-lightbox/style.css";

const EditBarcodeProduct = (props) => {
  const { visible, onClose, form, values, barcodeId, refetchData } = props
  const { validateFields, getFieldDecorator, resetFields, setFieldsValue } =
    form
  const barcodeProductCategories = values

  const [loading, setLoading] = useState(false)
  const [imageUrl, setImageUrl] = useState('')
  const [file, setFile] = useState(null)
  const [current, setCurrent] = useState('')


  const dispatch = useDispatch()
  const { barcodeDetail } = useSelector(
    (state) => ({
      barcodeDetail: state.barcodeProduct.barcodeDetail
    }),
    []
  )

  useDeepEffect(() => {
    async function fetchData() {
      await dispatch(getBarcodeById(barcodeId))
    }

    if (!_.isUndefined(barcodeId)) {
      fetchData()
    }

    return () => {
      dispatch(saveSelectedList([]))
    }
  }, [barcodeId])

  useDeepEffect(() => {
    if (!_.isEmpty(barcodeDetail)) {
      dispatch(saveSelectedList([]))
      setFieldsValue({
        barcodeProductName: barcodeDetail.name,
        barcodeNo: barcodeDetail.barcodeData,
        brand: barcodeDetail.brand,
        barcodeCategoryId: barcodeDetail.categoryId
      })

      setImageUrl(barcodeDetail.image)
    }
  }, [barcodeDetail])

  const uploadButton = (
    <div>
      <Icon type={loading ? 'loading' : 'plus'} />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  const handleClickImage = (e, image) => {
    e && e.preventDefault();
    setCurrent(image)
  };

  const handleCloseModal = e => {
    e && e.preventDefault();
    setCurrent('')
  };

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const formData = new FormData()
        formData.append('barcodeId', barcodeId)
        formData.append('name', values.barcodeProductName)
        formData.append('barcode', values.barcodeNo)
        formData.append('brand', values.brand)
        formData.append('barcodeCategoryId', values.barcodeCategoryId)

        if (!_.isNull(file)) {
          formData.append('image', await compressFile(file))
        }

        await dispatch(saveBarcodeProduct(formData, 'edit'))
        await resetFields()
        await onClose()
        await setFile(null)
        await setImageUrl('')
        await refetchData()
      }
    })
  }

  const handleChange = async (info) => {
    await setLoading(true)
    await getBase64(info.file, (imageUrl) => {
      setLoading(false)
      setImageUrl(imageUrl)
    })
  }

  return (
    <Modal
      width={800}
      visible={visible}
      title="Edit BarcodeProduct"
      okText="Edit"
      onCancel={onClose}
      footer={null}>
      <Tabs>
        <Tabs.TabPane tab="Product" key="1">
          <Form onSubmit={onSubmit}>
            <Form.Item label="ชื่อ BarcodeProduct">
              {getFieldDecorator('barcodeProductName', {
                rules: [
                  { required: true, message: 'กรุณาใส่ชื่อ BarcodeProduct' }
                ]
              })(
                <Input
                  name="barcodeProductName"
                  placeholder="BarcodeProduct Name"
                />
              )}
            </Form.Item>
            <Form.Item label="Barcode No.">
              {getFieldDecorator('barcodeNo', {
                rules: [{ required: true, message: 'กรุณาใส่ชื่อ Barcode No.' }]
              })(<Input name="barcodeNo" placeholder="Barcode No." />)}
            </Form.Item>
            <Form.Item label="ยี่ห้อสินค้า">
              {getFieldDecorator('brand', {
                rules: [{ required: true, message: 'กรุณาใส่ชื่อยี่ห้อสินค้า' }]
              })(<Input name="brand" placeholder="ยี่ห้อสินค้า" />)}
            </Form.Item>
            <Form.Item label="หมวดหมู่">
              {getFieldDecorator('barcodeCategoryId', {
                rules: [{ required: true, message: 'กรุณาเลือกหมวดหมู่' }]
              })(
                <Select>
                  {barcodeProductCategories &&
                    barcodeProductCategories.map((item) => {
                      return (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      )
                    })}
                </Select>
              )}
            </Form.Item>
            <Form.Item label="รูปหน้าปก">
              {getFieldDecorator('cover', {
                rules: [
                  {
                    required: _.isEmpty(imageUrl),
                    message: 'กรุณาเลือกรูปหน้าปก'
                  }
                ]
              })(
                <div>
                  <Row type="flex" justify="center">
                    <Col>
                      <Upload
                        name="avatar"
                        listType="picture-card"
                        showUploadList={false}
                        beforeUpload={(file) => beforeUpload(file, setFile)}
                        onChange={handleChange}>
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt="avatar"
                            style={{ width: '100%' }}
                          />
                        ) : (
                          uploadButton
                        )}
                      </Upload>
                    </Col>
                  </Row>
                  {imageUrl ? (
                    <Row type="flex" justify="center">
                      <div>
                        <Button onClick={e => handleClickImage(e, imageUrl)}>View</Button>
                        {current && (
                          <Lightbox mainSrc={current} onCloseRequest={handleCloseModal} />
                        )}
                      </div>
                    </Row>
                  ) : (
                    <div></div>
                  )}
                </div>
              )}
            </Form.Item>
            <Row type="flex" justify="end">
              <Button type="primary" htmlType="submit">
                Save
              </Button>
            </Row>
          </Form>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Product Recycle" key="2">
          <ProductRecycleList barcodeId={barcodeId} />
        </Tabs.TabPane>
      </Tabs>
    </Modal >
  )
}

const WrappedEditBarcodeProduct = Form.create({
  name: 'EditBarcodeProduct'
})(EditBarcodeProduct)

export default WrappedEditBarcodeProduct
